import { api } from '../../../apiAxios';
import { urlHttpGov } from '../../../urls';
import { getToken } from '../../../LStorage/token';
import { ICreateReceiptConfigDTO } from '../../../../pages/Recibos/components/ConfigurarRecibos/useConfigurarRecibos';

class RecibosConfigurarService {
    private baseURL: string = `${urlHttpGov}${process.env.REACT_APP_BACKEND === 'local' ? '' : '/gestor'}/receipt/config`;

    async getRecibosConfig(idEntity?: number, signal?: AbortSignal): Promise<ICreateReceiptConfigDTO | null> {

        let { data } = await api.get(`${this.baseURL}/entity/${idEntity}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async postRecibosConfig(
        obj: any,
        signal?: AbortSignal
    ): Promise<any> {

        let { data } = await api.post(`${this.baseURL}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }

    async putRecibosConfig(
        id: number,
        obj: any,
        signal?: AbortSignal
    ): Promise<any> {

        let { data } = await api.put(`${this.baseURL}/${id}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RecibosConfigurarService();
